import { render } from "./EditUritus.vue?vue&type=template&id=2f462779&scoped=true"
import script from "./EditUritus.vue?vue&type=script&lang=js"
export * from "./EditUritus.vue?vue&type=script&lang=js"

import "./EditUritus.vue?vue&type=style&index=0&id=2f462779&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f462779"]])

export default __exports__